import { render, staticRenderFns } from "./EvaluationScales.vue?vue&type=template&id=1389977d"
import script from "./EvaluationScales.vue?vue&type=script&lang=js"
export * from "./EvaluationScales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports